import React from "react";
import { Card, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { School, MapPin, User, Phone, Mail, BadgeCent } from "lucide-react";
import { Pencil, Trash } from "lucide-react";
import localization from "services/localization";

export function OrganizationCard({ school, onEnter, showActions = false, onEdit, onDelete, onCredit }) {
  return (
    <Card className="hover:shadow-lg transition-shadow cursor-pointer mb-4 p-3 rounded-2xl border common-card">
      <Card.Body className="flex flex-col justify-between flex-grow-1">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex items-start gap-4 min-w-0 flex-1">
            <div className="main-icon flex h-12 w-12 items-center justify-center rounded-xl shadow-md flex-shrink-0">
              <School size={26} />
            </div>

            <div className="flex flex-col min-w-0 flex-1">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`school-name-${school.id}`}>{school.name}</Tooltip>}
              >
                <h5 className="truncate-text font-bold text-lg m-0">{school.name}</h5>
              </OverlayTrigger>

              {school.type && (
                <span className="inline-block self-start text-xs capitalize px-2 py-0.5 rounded-full whitespace-nowrap badge-color">
                  {school.type}
                </span>
              )}
            </div>
          </div>

          {showActions && (
            <div className="flex gap-2 flex-shrink-0">
              {/* <Button
                variant="light"
                size="sm"
                className="p-1"
                onClick={(e) => {
                  e.stopPropagation();
                  onCredit(school);
                }}
              >
                <BadgeCent size={16} className="text-primary" />
              </Button> */}

              <Button
                variant="light"
                size="sm"
                className="p-1"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(school);
                }}
              >
                <Pencil size={16} className="text-primary" />
              </Button>

              <Button
                variant="light"
                size="sm"
                className="p-1 text-danger"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(school);
                }}
              >
                <Trash size={16} className="text-danger" />
              </Button>
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3 text-sm pt-2">
          {school.address && (
            <div className="flex items-start gap-2 page-subtitle">
              <MapPin size={16} className="mt-1 sub-icon" />
              <div className="flex flex-col">
                <span>
                  {school.address}, {school.city}
                </span>
              </div>
            </div>
          )}

          {school.dirigente_scolastico && (
            <div className="flex items-start gap-2 page-subtitle">
              <User size={16} className="mt-1 sub-icon" />
              <div className="flex flex-col">
                <span>{school.dirigente_scolastico}</span>
              </div>
            </div>
          )}

          {school.contact_phone?.length > 0 && (
            <div className="flex items-start gap-2 page-subtitle">
              <Phone size={16} className="mt-1 sub-icon" />
              <div className="flex flex-col">
                <span>{school.contact_phone[0]}</span>
              </div>
            </div>
          )}

          {school.contact_email?.length > 0 && (
            <div className="flex items-start gap-2 page-subtitle">
              <Mail size={16} className="mt-1 sub-icon" />
              <div className="flex flex-col">
                <span>{school.contact_email[0]}</span>
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-end mt-auto pt-4">
          <Button className="action-btn" size="sm" onClick={() => onEnter(school)}>
            {localization.enter_organization || "Enter Organization"}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
